module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('b-container', [_c('b-row', {
    staticClass: "header-items"
  }, [_c('b-col', {
    staticClass: "header-items__icon mr-auto",
    attrs: {
      "cols": "1"
    }
  }, [_c('b-navbar-brand', [_c('img', {
    attrs: {
      "src": _vm.image_src
    }
  })])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "ml-auto pull-left",
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "cols": "6"
    }
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "md"
    }
  }, [_c('b-navbar-nav', _vm._l((_vm.tab_states), function(item) {
    return _c('b-nav-item', {
      key: item.name,
      staticClass: "head-items__item",
      class: {
        'head-items__item--select_header': item.isActive
      },
      attrs: {
        "to": item.path
      },
      on: {
        "click": function($event) {
          return _vm.ontab(item.path)
        }
      }
    }, [_c('span', {
      class: {
        'head-items__item--select_tab': item.isActive
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d54265b","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageheader.vue
// module id = 650
// module chunks = 0